import * as serverReq from "./usersCrud";
import {usersSlice} from "./usersSlice";
import {errorMessage} from "../../../../util/Helpers"

const {actions} = usersSlice;


/* Api Request Error Handler */
const errorHandler = dispatch => error => {
    if (error?.message && error.message === "Cancel Request") return;
    dispatch(actions.userNotification({notification: {type: "error", message: errorMessage(error)}}));
}

export const clearNotification = _ => dispatch => dispatch(actions.userNotification({notification: null}));

/* Load Users Action */
export const fetchUsers = _ => dispatch => {
    serverReq.getAllUsers()
        .then(({data}) => dispatch(actions.usersFetched({data})))
        .catch(errorHandler(dispatch));
};

/* Load Search Users Action */
export const searchUsers = query => dispatch => {
    dispatch(actions.isLoading());
    serverReq.getSearchUsers(query)
        .then(({data}) => dispatch(actions.usersFetched({data})))
        .catch(errorHandler(dispatch));
};

/* Add new User Action */
export const addUser = userData => dispatch => {
    dispatch(actions.isLoading());
    serverReq.addUser(userData)
        .then(({data}) => dispatch(actions.userCreated({...data})))
        .catch(errorHandler(dispatch));
};

/* Update existing user Action */
export const updateUser = userData => dispatch => {
    serverReq.updateUser(userData)
        .then(({data}) => dispatch(actions.userUpdated({data})))
        .catch(errorHandler(dispatch));
};

/* Delete existing user Action */
export const deleteUser = id => dispatch => {
    serverReq.deleteUser(id)
        .then(({data: {id}}) => dispatch(actions.userDeleted({id})))
        .catch(errorHandler(dispatch));
};
